import React, { useState, useEffect ,useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { ListMembers, MembersDelete, MembersBulkDelete } from '../store/slices/members.js';
import Navbarside from './Navbarside';
import Loader from '../common/Loader';
import Footer from './Footer';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../common/Table';
import AdminLayout from './AdminLayout';
import { FaFileExcel } from "react-icons/fa";
import {toast } from 'react-hot-toast';
import {excelMembersMasterDownload } from "../common/ExcelDownload"

const MembersMaster = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef=useRef(null)

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;
  const Name = user?.data?.company_name;

  const [isLoading, setIsLoading] = useState(false);
  const [listmembers, setListMembers] = useState([]);
        const [selectedRows, setSelectedRows] = useState([]);  // Stores selected row IDs
        const [selectAll, setSelectAll] = useState(false);
    const [selectedParty, setSelectedParty] = useState(null);
  const [columns, setcolumns] = useState([
      { header: 'Checkbox', field: 'Checkbox' },
    { header: 'Name', field: 'member_name'},
    { header: 'Email', field: 'email'},
    { header: 'Folio No', field: 'folio_no'},
    { header: 'Date', field: 'added_on'},
    { 
      header: 'Actions', 
      field: 'actions', 
      isAction: true, 
      actionButtons: [
        { name: 'Edit', className: 'btn-default' }, 
        { name: 'Delete', className: 'btn-cancel' },
      ]
    }
  ]);
 

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
      navigate(`/members/edit/${item.id ? item.id : null}`)
  };

  const fetchListMembers = async () => {
    setIsLoading(true);
    dispatch(ListMembers({ profile_id: id }))
      .unwrap()
      .then((data) => {
        setIsLoading(false);
        setListMembers(data?.data);
      })
      .catch(({ message }) => {
        setIsLoading(false);
        setListMembers([]);
        console.log(message);
      });
  };

  const handleDelete = (item) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this Member?');
    if (confirmDelete) {
      setIsLoading(true);
      dispatch(MembersDelete({ id: item.id, profile_id: id }))
        .unwrap()
        .then(() => {
          setIsLoading(false);
          fetchListMembers();
        })
        .catch(({ message }) => {
          setIsLoading(false);
          toast.error(message);
        });
    }
  };

  const handleDeleteBulk = () => {
    if (!selectedRows || selectedRows?.length === 0) {
      alert('Please select at least one Member.');
      return;
    }

    const confirmDelete = window.confirm('Are you sure you want to delete selected Members?');
    if (confirmDelete) {
      setIsLoading(true);
      dispatch(MembersBulkDelete({ ids: selectedRows, profile_id: id }))
        .unwrap()
        .then(() => {
          setIsLoading(false);
          setSelectedRows([]);
          setSelectAll(false);
          fetchListMembers();
        })
        .catch(({ message }) => {
          setIsLoading(false);
          toast.error(message);
        });
    }
  };


 
  React.useEffect(() => {
    fetchListMembers();
  }, [dispatch]);


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter data based on search query
  const filteredParties = listmembers?.filter(party => 
    party?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.address?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.email?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.phone?.toLowerCase()?.includes(searchQuery?.toLowerCase())||
    party?.date_added?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

      const handleExcelDownload = () => {
      if (!listmembers || listmembers.length === 0) {
          alert("No data available for download.");
          return;
      }
  
      const selectedInvoices = selectAll && listmembers.length > 0
          ? listmembers.map(invoice => invoice.id)
          : selectedRows;
  
      if (!selectedInvoices || selectedInvoices.length === 0) {
          alert("Please select at least one MembersMaster.");
          return;
      }
  
      const selectedData = listmembers.filter(invoice => selectedInvoices.includes(invoice.id));
  
      if (selectedData.length === 0) {
          alert("No matching MembersMaster found.");
          return;
      }
  
      try {
        excelMembersMasterDownload(selectedData, "MembersMaster.xlsx");
          toast.success("Downloading Excel file successfully!");
      } catch (error) {
          console.error("Error downloading Excel file:", error);
          alert("Failed to download the Excel file. Please try again.");
      }
  };
  return (
    <AdminLayout>
        {isLoading && <Loader />}
          <div className="row content-body">
            <div className="container-fluid">
              <div className="page-header">
                <div>
                  <h2 className="main-content-title tx-24 mg-b-5">Member's Master</h2>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Registers</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                       Member's List
                    </li>
                  </ol>
                </div>
                <div className="d-flex justify-content-end">
                     <button className="btn ripple btn-cancel" onClick={handleDeleteBulk}>
                      Delete Members
                    </button>
                  <button className="btn ripple btn-default" onClick={() => navigate('/members/create')}>
                      Add Member
                  </button>
                     <button className="btn ripple btn-default"   onClick={handleExcelDownload} >
                                                     Export Excel <FaFileExcel/>
                                                    </button>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12"> 
                 <Table
                    columns={columns}
                    data={filteredParties} 
                    tableRef={tableRef}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    currentPage={currentPage}
                    totalCount={filteredParties.length} 
                    onPageChange={handlePageChange}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    handleSearchChange={handleSearchChange}
                     selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows} 
                    selectAll={selectAll} 
                    setSelectAll={setSelectAll} 
                  />
                </div>
              </div>
            </div>
          </div>
        </AdminLayout>
  );
};

export default MembersMaster;
